import { render } from "./CarouselComponent.vue?vue&type=template&id=6bd8e6a0&scoped=true&ts=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=ts"
export * from "./CarouselComponent.vue?vue&type=script&lang=ts"

import "./CarouselComponent.vue?vue&type=style&index=0&id=6bd8e6a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd8e6a0"]])

export default __exports__